<template>
  <v-dialog persistent v-model="visible" @keydown.esc="close">
    <v-card :loading="loading">
      <v-card-title>关键词趋势图</v-card-title>
      <v-card-subtitle>ASIN: {{ item ? item.asin : "" }}, 关键词: {{ item ? item.key : "" }}</v-card-subtitle>
      <v-card-text>
        <v-tabs grow v-model="selectedType">
          <v-tab v-for="type of types" :key="type.value">{{ type.text }}</v-tab>
        </v-tabs>
        <highcharts :options="chartOptions"></highcharts>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-responsive max-width="150">
          <v-select :items="days" v-model="selectedDays" @change="getData"/>
        </v-responsive>
        <v-spacer/>
        <v-btn text color="primary" @click="close">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {Chart} from "highcharts-vue";

export default {
  name: "KeywordTrendDialog",
  components: {
    highcharts: Chart
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    item: Object
  },
  data() {
    return {
      loading: false,
      types: [
        {text: "排名", value: 0},
        {text: "广告排名", value: 1},
        {text: "搜索量", value: 2},
        {text: "搜索趋势", value: 3},
      ],
      days: [
        {text: "最近30条记录", value: 30},
        {text: "最近90条记录", value: 90},
        {text: "无限制", value: 0}
      ],
      items: [],
      selectedType: null,
      selectedDays: 30,
      chartOptions: {
        title: {
          text: ""
        },
        xAxis: {
          categories: [],
          reversed: true
        },
        yAxis: {
          title: {
            text: ""
          },
          reversed: false
        },
        series: [
          {
            name: "",
            data: []
          }
        ],
      }
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$axios.get(`/keyword/${this.item.asin}/${this.item.key}/records/${this.selectedDays}`).then(
          response => {
            this.items = response.data;
            this.selectedType = "排名";
            this.loading = false;
          }
      );
    },
    close() {
      this.$emit("update:visible", false);
    },
    getTypeText() {
      if (this.selectedType === 1) {
        this.chartOptions.yAxis.reversed = true;
        return "广告排名";
      } else if (this.selectedType === 2) {
        this.chartOptions.yAxis.reversed = false;
        return "搜索量";
      } else if (this.selectedType === 3) {
        this.chartOptions.yAxis.reversed = false;
        return "搜索趋势";
      } else {
        this.chartOptions.yAxis.reversed = true;
        return "排名";
      }
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.getData();
        // this.chartOptions.subtitle.text = `ASIN: ${this.item.asin}`;
      }
    },
    selectedType() {
      let line = {
        name: this.getTypeText(),
        data: []
      };
      let categories = [];
      if (this.items && this.items.length > 0) {
        for (let item of this.items) {
          if (this.selectedType === 1 && item.sponsoredRank !== undefined) {
            line.data.push(item.sponsoredRank);
            categories.push(item.recordDate);
          } else if (this.selectedType === 2 && item.searchVolume !== undefined) {
            line.data.push(item.searchVolume);
            categories.push(item.recordDate);
          } else if (this.selectedType === 3 && item.searchVolumeTrend !== undefined) {
            line.data.push(item.searchVolumeTrend);
            categories.push(item.recordDate);
          } else if (this.selectedType === 0 && item.organicRank !== undefined) {
            line.data.push(item.organicRank);
            categories.push(item.recordDate);
          }
        }
      }
      this.chartOptions.series = [line];
      this.chartOptions.xAxis.categories = categories;
    },

  }
}
</script>

<style scoped>

</style>